<template>
      <v-card style="overflow:hidden">
        <v-card-title class="headline brown darken-4" style="font-size:32px!important; color:white"> 
          New Store
          <v-spacer/>
          <v-btn v-if="!store.open" color="blue" @click="swapStore" class="mb-2 ml-2"> Open Store </v-btn>
          <v-btn v-else color="blue" @click="swapStore"> Close Store </v-btn>
        </v-card-title>              
        <div v-if="store.open">          
            <v-img :src="require('../assets/dark parchment background.jpg')" class="repeaty2" contain>
          <v-row>
            <v-col v-for="item in store.remainingItems" v-bind:key="item.id" cols="12" sm="2">
              <v-card dark :img="require('../assets/Background_grey.png')">
                <v-card-title style="justify-content:center;">{{item.typed ? "Typed" : ""}} {{item.name}}</v-card-title>
                  <div v-if="item.specific"><picker-card :item="item.option"></picker-card></div>
                  <div v-if="item.boughtBy == ''" style="text-align:center;"> Price: {{item.price}} </div>   
                  <div v-if="item.boughtBy != ''" style="text-align:center; color:red;"> Bought By: {{item.boughtBy}}</div>
              </v-card>
            </v-col>
          </v-row>                                  
            </v-img>
        </div>
        <div v-else>
            <v-img :src="require('../assets/dark parchment background.jpg')" class="repeaty2" contain>
          <div class="ml-2">
            <div style="display: flex;">
                <b style="font-size:22px" class="mr-1">Discount Amount:</b> <b><v-text-field style="max-width:30px; font-size:18px; text-align-last: center;" v-model.number="store.discount" dense></v-text-field></b>
            </div>
            Store Type:
            <v-btn :color="`${currentStoreType == 'basic' ? 'green' : ''}`" @click="setStoreType('basic'); changeAllSubs()" class="ma-1">Basic</v-btn>
            <v-btn :color="`${currentStoreType == 'offense' ? 'green' : ''}`" @click="setStoreType('offense'); changeAllSubs()" class="ma-1">Destruction</v-btn>
            <v-btn :color="`${currentStoreType == 'defense' ? 'green' : ''}`" @click="setStoreType('defense'); changeAllSubs()" class="ma-1">Protection</v-btn>
            <v-btn :color="`${currentStoreType == 'items' ? 'green' : ''}`" @click="setStoreType('items'); changeAllSubs()" class="ma-1">Armory</v-btn>
            <v-btn :color="`${currentStoreType == 'training' ? 'green' : ''}`" @click="setStoreType('training'); changeAllSubs()" class="ma-1">Training Hall</v-btn>
            <v-btn :color="`${currentStoreType == 'ascension' ? 'green' : ''}`" @click="setStoreType('ascension'); changeAllSubs()" class="ma-1">Hall of Ascension</v-btn>
            <v-btn :color="`${currentStoreType == 'inn' ? 'green' : ''}`" @click="setStoreType('inn'); changeAllSubs()" class="ma-1">Inn</v-btn>
            <v-btn :color="`${currentStoreType == 'discount' ? 'green' : ''}`" @click="setStoreType('discount'); changeAllSubs()" class="ma-1">Bargain</v-btn>
            <v-btn :color="`${currentStoreType == 'magic' ? 'green' : ''}`" @click="setStoreType('magic'); changeAllSubs()" class="ma-1">Magic</v-btn>
          </div>          
          <v-tabs v-model="storeTab" class="mb-1" dark>
              <v-tab v-for="tab in storeTabs" :key="tab">{{tab}}</v-tab>
          </v-tabs>
          <v-row class="mb-2">
              <v-tabs-items v-model="storeTab" style="width:100%; background-color:transparent">
                <v-tab-item item v-for="tab in storeTabs" :key="tab">
                    <div class="ml-6 mt-5" v-if="currentStoreType != ''">
                        Bonus:
                        <v-btn class="ma-1" v-if="storeTab==0" @click="bonus('stats')">Stats</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==0" @click="bonus('feats')">Feats</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==0" @click="bonus('levels')">Level Ups</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==1" @click="bonus('armor')">Armor</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==1" @click="bonus('weapons')">Weapons</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==1" @click="bonus('weaponEnchantments')">Weapon Enchantments</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==1" @click="bonus('armorEnchantments')">Armor Enchantments</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==1" @click="bonus('itemTrades')">Item Trades</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==2" @click="bonus('perk')">Perks</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==2" @click="bonus('subPerks')">Sub Perks</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==3" @click="bonus('spells')">Spells</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==3" @click="bonus('maneuvers')">Maneuvers</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==4" @click="bonus('wonderousItems')">Wonderous Items</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==4" @click="bonus('gear')">Gear</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==4" @click="bonus('basicPotions')">Basic Potions</v-btn>
                        <v-btn class="ma-1" v-if="storeTab==4" @click="bonus('specialRestoratives')">Special Restoratives</v-btn>
                    </div>
                    <div v-for="item in store.possibleItems" v-bind:key="item.item">
                        <v-col v-if="item.storeType == tab || (!item.storeType && tab=='gear')">
                            <v-card :img="require('../assets/Background_white.png')" dark>
                                <v-card-title class="headline brown darken-4" style="color:white">{{item.item}}
                                    <v-spacer/>
                                    <v-btn @click="double(item)">Double</v-btn>
                                </v-card-title>
                                <v-row class="pl-2 ml-2" style="align-items:baseline">
                                Amount: <v-text-field @change="changeSubCount(item)" style="max-width:50px;" v-model="item.defaultAmount"></v-text-field>                                
                                </v-row>
                                <v-row  class="pl-2 ml-2" style="align-items:baseline;">
                                Price: <v-text-field style="max-width:50px" v-model="item.price" @change="updateSubPrices(item, store.possibleItems)"></v-text-field>
                                </v-row>
                                <v-row class="pa-0 ma-0" style="align-items:baseline">
                                    <v-col lg="2" md="3" sm="4" class="mb-1 mr-0 ml-0 pl-1 pr-1" v-for="subItem in item.list" :key="subItem.id">
                                        <v-card class="pl-0 mr-0" :img="require('../assets/Background_grey.png')" dark>
                                            <v-row style="display:flex; align-items:center;justify-content:space-around;" class="mr-0 ml-0">
                                                Item {{subItem.id + 1}}
                                                <v-checkbox v-if="item.canBeSpecific" v-model="subItem.specific" @click="update(item, store.possibleItems); subItem.typed = false; subItem.price = parseInt(item.price) + 25" label="Specific"></v-checkbox>
                                                <v-checkbox v-if="item.canBeTyped" v-model="subItem.typed" @click="update(item, store.possibleItems); subItem.specific = false; subItem.price = parseInt(item.price) + 25" label="Typed"></v-checkbox>
                                            </v-row>
                                            <v-divider/>
                                            <div v-if="subItem.typed" style="display:flex; align-items:baseline; justify-content: center;">
                                                Price: <v-text-field style="max-width:50px" class="mt-1 pt-1" v-model="subItem.price"></v-text-field>
                                            </div>
                                            <div v-if="subItem.specific" class="ml-1">
                                                <v-row dense class="mr-5" style="justify-content:center; align-items:baseline;">
                                                    Price: <v-text-field style="max-width:50px" class="mt-1 pt-1" v-model="subItem.price"></v-text-field>
                                                </v-row>
                                                <div v-if="subItem.options && !subItem.options.sub">
                                                    <div v-if="subItem.options && subItem.options.rarity">
                                                        Rarity                
                                                        <v-row >     
                                                            <v-col sm="4" v-for="rarity in objectify(subItem.options.rarity)" :key="rarity">
                                                                <v-checkbox dense height="11px" class="small-label" v-model="subItem.options.rarity[rarity]" :label="rarity"></v-checkbox>
                                                            </v-col>
                                                        </v-row>
                                                    </div>
                                                    <div v-if="subItem.options && subItem.options.type">
                                                        Type             
                                                        <v-row>        
                                                            <v-col sm="4" v-for="type in objectify(subItem.options.type)" :key="type">
                                                                <v-checkbox dense height="11px" class="small-label" v-model="subItem.options.type[type]" :label="type"></v-checkbox>
                                                            </v-col>
                                                        </v-row>
                                                    </div>
                                                </div>
                                                <v-row class="ma-1" v-if="subItem.options && subItem.options.weapon">
                                                    Weapon Type
                                                    <v-row class="pa-1 my-1">
                                                        <v-col class="pa-1" sm="5" v-for="wepType in objectify(subItem.options.weapon.type)" :key="wepType">
                                                            <v-checkbox dense height="20px" class="small-label" v-model="subItem.options.weapon.type[wepType]" :label="wepType"></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                    Weapon Rarity
                                                    <v-row class="pa-1 my-1">
                                                        <v-col class="pa-1" sm="4" v-for="wepRarity in objectify(subItem.options.weapon.rarity)" :key="wepRarity">
                                                            <v-checkbox dense height="20px" class="small-label" v-model="subItem.options.weapon.rarity[wepRarity]" :label="wepRarity"></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                    Weapon Enchantment Rarity
                                                    <v-row class="pa-1 my-1">
                                                        <v-col class="pa-1" sm="4" v-for="enchRarity in objectify(subItem.options.weaponEnchantments.rarity)" :key="enchRarity">
                                                            <v-checkbox dense height="20px" class="small-label" v-model="subItem.options.weaponEnchantments.rarity[enchRarity]" :label="enchRarity"></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                </v-row>
                                                <v-row class="ma-1" v-if="subItem.options && subItem.options.armor">
                                                    Armor Type
                                                    <v-row class="pa-1 my-1">
                                                        <v-col class="pa-1" sm="4" v-for="armrType in objectify(subItem.options.armor.type)" :key="armrType">
                                                            <v-checkbox dense height="20px" class="small-label" v-model="subItem.options.armor.type[armrType]" :label="armrType"></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                    Armor Rarity
                                                    <v-row class="pa-1 my-1">
                                                        <v-col class="pa-1" sm="4" v-for="armrRarity in objectify(subItem.options.armor.rarity)" :key="armrRarity">
                                                            <v-checkbox dense height="20px" class="small-label" v-model="subItem.options.armor.rarity[armrRarity]" :label="armrRarity"></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                    Armor Enchantment Rarity
                                                    <v-row class="pa-1 my-1">
                                                        <v-col class="pa-1" sm="4" v-for="enchRarity in objectify(subItem.options.armorEnchantments)" :key="enchRarity">
                                                            <v-checkbox dense height="20px" class="small-label" v-model="subItem.options.armorEnchantments[enchRarity]" :label="enchRarity"></v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                </v-row>
                                            </div>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </div>
                </v-tab-item>
              </v-tabs-items>
          </v-row>   
        </v-img>       
        </div>        
      </v-card>    
</template>

<script>
import PickerCard from "./PickerCard"
import storePresents from "./storePresents"
import dataGenerator from "./dataGenerator"
import {storeItems, potions as potionsList} from "./data"
export default {
    components: {
        PickerCard,
    },
    props:{
        players: [],
        storeCommand:{},
    },
    data(){
      return{
          store:{
            open:false,
            discount:0,
            remainingItems:[],
            possibleItems:[],
        },
        storeReady:false,
        storeTab: 0,
        storeTabs:["character","equipment","perk","spells/maneuvers", "gear"],
        currentStoreType:"",
        bonuses:[]
      }
    },
    mounted(){
        let x = 0
        storeItems.forEach(item =>{
            item.id = x++
            this.store.possibleItems.push(item)
        })                
        this.openStoreDialog()
        this.bonuses["stats"] = [0.75,"stats"]
        this.bonuses["feats"] = [0.90,"Feat", "Specific Feat","Specific Martial Feat","Specific Magic Feat","Teamwork Feat"]
        this.bonuses["levels"] = [0.75,"Level Up"]
        this.bonuses["armor"] = [0.85, "armor", "enchanted armor"]
        this.bonuses["weapons"] = [0.85,"weapon", "enchanted weapon"]
        this.bonuses["weaponEnchantments"] = [0.75,"weapon enchantment"]
        this.bonuses["armorEnchantments"] = [0.75,"armor enchantment"]
        this.bonuses["itemTrades"] = [0.5,"Item Trade"]
        this.bonuses["perk"] = [0.75,"Perk"]
        this.bonuses["subPerks"] = [0.90, "Rage Power","Rogue Talent","Ki Power","Fighter Perk","Recovery Perk"]
        this.bonuses["spells"] = [0.80, "Spell", "Typed Spell"]
        this.bonuses["maneuvers"] = [0.80, "Maneuver", "Typed Maneuver","Maneuver From School", "Finisher"]
        this.bonuses["wonderousItems"] = [0.70, "wonderousItems"]
        this.bonuses["gear"] = [0.75, "Gear","Specific Gear"]
        this.bonuses["basicPotions"] = ["curative","mnemonic"]
        this.bonuses["specialRestoratives"] = ["restorative", "ressurective"]
    },
    watch:{
        storeCommand(){
            if(this.storeCommand.type == "newPlayer"){                
                if(this.store.open){
                    this.storeCommand.connection.send(JSON.stringify({command:"newRoll", type:"newStore", remainingItems:this.store.remainingItems}))
                }
            }else if(this.storeCommand.type == "itemBought"){
                this.itemBought(this.storeCommand)
            }else if(this.storeCommand.type == "update"){
                this.openStoreDialog()
            }
        }
    },
    methods:{
        openStoreDialog(){
            //if(this.players.length > 0){
                if(this.currentStoreType) this.currentStoreType = ""                
                let highestLevel = this.getHighestLevel()
                this.store.possibleItems.forEach(item =>{
                    if(item.type){
                        if(item.type == "curative" || item.type == "mnemonic"){
                            if(potionsList[item.potionId-1].minLvl < highestLevel-2){
                                item.defaultAmount = 5
                                item.price = 3
                            }else if(potionsList[item.potionId-1].minLvl == highestLevel-2){
                                item.defaultAmount = 5
                                item.price = 5
                            }else if(potionsList[item.potionId-1].minLvl == highestLevel-1){
                                item.defaultAmount = 4
                                item.price = 10
                            }else if(potionsList[item.potionId-1].minLvl == highestLevel){
                                item.defaultAmount = 3
                                item.price = 15
                            }else if(potionsList[item.potionId-1].minLvl == highestLevel+1){
                                item.defaultAmount = 2
                                item.price = 20
                            }else if(potionsList[item.potionId-1].minLvl == highestLevel+2){
                                item.defaultAmount = 1
                                item.price = 30
                            }
                        }
                        if(item.type == "restorative"){
                            if(potionsList[item.potionId-1].minLvl <= highestLevel && (potionsList[item.potionId-1].minLvl != 1 || potionsList[item.potionId-1].name == "Lesser Restoration")){
                                item.defaultAmount = 2 + Math.floor((highestLevel - potionsList[item.potionId-1].minLvl)/2)
                                item.price = item.price - 5 * Math.floor((highestLevel - potionsList[item.potionId-1].minLvl)/2)
                                if(item.price < 5) item.price = 5
                            }
                        }            
                        if(item.type == "ressurective"){
                            if(potionsList[item.potionId-1].minLvl <= highestLevel){
                                item.defaultAmount = 2 + Math.floor((highestLevel - potionsList[item.potionId-1].minLvl)/2)
                                item.price = item.price - 5 * Math.floor((highestLevel - potionsList[item.potionId-1].minLvl)/2)
                                if(item.price < 5) item.price = 5
                            }
                        }
                    }else if(!item.specific && (item.canBeSpecific || item.canBeTyped)){                        
                        item.list = []
                        for(let x = 0; x < item.defaultAmount; x++){
                            let newItem = {specific:false, typed:false, id:x}
                            if(item.options) newItem.options = this.unreference(item.options)
                            newItem.price = item.price
                            item.list.push(newItem)
                        }
                    }else if(item.item == "Specific Gear"){
                         item.list = []
                         for(let x = 0; x < item.defaultAmount; x++){
                            let newItem = {specific:true, typed:false, id:x}
                            if(item.options) newItem.options = this.unreference(item.options)
                            newItem.price = item.price
                            item.list.push(newItem)
                        }
                    }
                })
            //} 
        },

        openStore(){
            let items = []
            let y = 0
            this.store.possibleItems.forEach(itemGroup=>{
                for(let x = 0; x < itemGroup.defaultAmount; x++){
                    let item = {}
                    if(itemGroup.type){
                        item.type = itemGroup.type
                        item.potionId = itemGroup.potionId
                    }
                    item.id = y
                    item.name = itemGroup.item
                    item.price = itemGroup.price
                    if(item.price > 0 && item.name != "Gambling") item.price = Math.ceil(itemGroup.price * (1-(this.store.discount/100)))
                    item.boughtBy = ""
                    item.storeType = itemGroup.storeType
                    if(itemGroup.desc) item.desc = itemGroup.desc
                    if(itemGroup.specific || (itemGroup.list && itemGroup.list[x].specific)){
                        let options = itemGroup.options
                        if(itemGroup.list) {
                            options = itemGroup.list[x].options
                            item.price = Math.ceil(itemGroup.list[x].price * (1-(this.store.discount/100)))                          
                        }
                        if(itemGroup.item == "Spell" || itemGroup.item == "Maneuver" || itemGroup.item == "Finisher"){
                            options.level = this.getSpellManeuverLevel(this.getHighestLevel(), itemGroup.specificType)
                        }
                        let roll = this.getRoll(itemGroup.specificType, options, 1)
                        roll = roll.length ? roll[0] : roll
                        roll.uiType = itemGroup.specificType
                        item.specific = true
                        item.option = roll
                        item.specificType = itemGroup.specificType
                    }
                    if(itemGroup.list && itemGroup.list[x].typed) {
                        item.typed = true                        
                        item.types = itemGroup.typesArr
                        item.specificType = itemGroup.specificType
                        item.price = Math.ceil(itemGroup.list[x].price * (1-(this.store.discount/100)))
                    }
                    items.push(item)
                    y++
                }
            })
            this.store.remainingItems = items
            let playerNames = this.players.map(player => player.playerName)
            this.players.forEach((player) => {
                this.$emit("sendData", {command:"newRoll", type:"newStore", remainingItems:this.store.remainingItems, playerNames}, player);                
            })
        },

        getSpellManeuverLevel(lvlNum, type){
            lvlNum++
            let min = type == "spells" ? 0 : 1
            if(lvlNum > 9){lvlNum = 9}
            let options = {level:{}}
            for(let x = 0; x < 4; x++){
                if(lvlNum-x >= min){   
                    let level = lvlNum-x
                    let levelString="lvl"+level;
                    options.level[levelString]=true;
                }
            }
            return options.level
        },

        closeStore(){
            this.store.remainingItems = []
            this.players.forEach((player) => {
                this.$emit("sendData", {command:"newRoll", type:"closeStore"}, player)
            })
        },

        getHighestLevel(){
            let levels = [1]
            if(this.players && this.players.length > 0){
                levels = this.players.map(player => player.characterSheet.characterStats.misc.level)
            }
            let highestLevel = 0            
            highestLevel = levels.sort(function(a, b){return b-a})[0]
            highestLevel = Math.ceil(highestLevel/2)
            if(highestLevel > 9) highestLevel = 9
            return highestLevel
        },

        getRoll(type, options, amount){
            return dataGenerator.roll(type, options, amount, [], ["all"], [])
        },

        swapStore(){
            this.$emit("swapStore")
            this.store.open = !this.store.open
            if(this.store.open){
                this.openStore()
            }else{
                this.closeStore()
            }
        },

        itemBought(command){
            console.log(this.store.remainingItems[command.item.item], boughtItem, command)
            let boughtItem = {id: command.item.item, name:this.store.remainingItems[command.item.item].name, boughtBy:command.item.fromPlayer.playerName, storeType: this.store.remainingItems[command.item.item].storeType, specific:this.store.remainingItems[command.item.item].specific, typed:this.store.remainingItems[command.item.item].typed}
            if(this.store.remainingItems[command.item.item].option) boughtItem.option = this.store.remainingItems[command.item.item].option
            if(this.store.remainingItems[command.item.item].specificType == "gear"){
                this.$emit("giveGear",this.store.remainingItems[command.item.item].option, this.store.remainingItems[command.item.item].option.stack)
            }
            if(this.store.remainingItems[command.item.item].type){
                this.$emit("givePotion", potionsList[this.store.remainingItems[command.item.item].potionId-1])
            }
            this.store.remainingItems.splice(boughtItem.id, 1, boughtItem)
            this.players.forEach((player) => {
                this.$emit("sendData", {command:"communalUpdate", type:"storeItemBought", itemId:boughtItem.id, boughtBy:boughtItem.boughtBy}, player);
            })            
            if(!boughtItem.specific && !boughtItem.typed){
                let message = {type:boughtItem.name}
                if(boughtItem.name && boughtItem.name == "Finisher" ){
                    message.type = "maneuver"
                    message.options = {}
                    message.options.type = {Finisher:true}
                }
                this.$emit("requestRoll", message, command.item.fromPlayer)
            }
        },

        objectify(array){
            return Object.keys(array)
        },

        unreference(obj){
            return JSON.parse(JSON.stringify(obj))
        },

        update(item, arr){
            arr.splice(item.id, 1, item)
        },

        bonus(item){
            console.log(this.store.possibleItems)
            if(item == "basicPotions" || item == "specialRestoratives"){
                this.bonusPotions(item)
                return
            }
            let items = this.bonuses[item]
            for(let x = 1; x < items.length; x++){                
                let storeItem = this.store.possibleItems.find(possibleItem=> possibleItem.item == items[x])
                storeItem.price = Math.ceil(storeItem.price * items[0])
                this.double(storeItem)
                if(storeItem.list){
                    this.updateSubPrices(storeItem, this.store.possibleItems)
                }
            }
        },
        bonusPotions(item){
            this.store.possibleItems.forEach(storeItem=>{
                if(this.bonuses[item].includes(storeItem.type)){
                    this.double(storeItem)
                }
            })
        },

        double(item){
            item.defaultAmount *= 2
            console.log("wait what?")
            console.log(item)
            if(item.list){
                let newList = []
                item.list.forEach(item =>{
                    newList.push(JSON.parse(JSON.stringify(item)))
                    newList.push(JSON.parse(JSON.stringify(item)))
                })
                for(let x = 0; x < newList.length; x+=2){
                    newList[x].id = x
                    newList[x+1].id = x+1
                    item.list.splice(x, 1, newList[x])
                    item.list.splice(x+1, 0, newList[x+1])
                }
                item.list.splice()
            }
        },

        changeAllSubs(){
            this.store.possibleItems.forEach(item=>{
                if(item.list){
                    this.changeSubCount(item)
                }
            })
        },

        changeSubCount(item){
            let diff = item.defaultAmount - item.list.length
            if(!item.type && !item.specific){
                if(diff > 0){
                    for(let x = 0; x < diff; x++){
                        let newItem = {specific:false, typed:false, id:item.list.length}
                        if(item.options){
                            newItem.options = this.unreference(item.options)                            
                        } 
                        newItem.price = item.price
                        item.list.push(newItem)
                    }
                }else{
                    for(let x = 0; x < diff*-1; x++){
                        item.list.pop()
                    }
                }
            }            
            this.update(item, this.store.possibleItems)
        },

        updateSubPrices(item, items){
            for(let x = 0; x < item.list.length; x++){
                item.list[x].price = parseInt(item.price) + 25
            }     
            items.splice(item.id,1,items[item.id])
        },

        setStoreType(type){
            this.currentStoreType = type
            storePresents.setStore(type, this.store.possibleItems)
        }
    },
}
</script>

<style>
.small-label .v-label{
  font-size:12px;
  margin-top:0px;
  margin-bottom:0px;
  padding-top:0px;
}
.small-label .v-messages.theme--light{
  height:0px;
  display:none;
}
.small-label .v-input--selection-controls__input{
  margin-right: 0px !important
}
 .repeaty2 .v-image__image{
  background-repeat: repeat-y!important;
  background-position: unset!important;
 }
</style>